import { useEffect, useRef } from 'react';
import { useWindows, type WindowID } from './Windows';
import { useVersions } from './VersionsPreview';
import { useConversation } from '@/services/ConversationService';

export function VersionsView() {
  const { state } = useVersions();
  const { state: conversationState } = useConversation();
  const hasHiddenRef = useRef(false);

  const { dispatch: windowDispatch, state: windowState } = useWindows();

  // TODO(LAB-327): Figure out why this renders in an infinite loop
  useEffect(() => {
    if (hasHiddenRef.current) {
      return;
    }
    hasHiddenRef.current = true;
    Object.keys(windowState.windows).forEach((windowID) => {
      const wID = windowID as WindowID;

      if (wID === 'versions') {
        windowDispatch({ type: 'show', id: wID });
      } else {
        windowDispatch({ type: 'hide', id: wID });
      }
    });
  }, [hasHiddenRef, windowDispatch, windowState.windows]);

  if (
    state.comparisonItems === undefined ||
    state.comparisonItems.length === 0
  ) {
    return <></>;
  }

  if (conversationState.type !== 'conversation') {
    return <></>;
  }

  return <></>;
}
